import type { IAction } from '../../action/IAction'
import { ActionArgs } from '../../action/ActionArgs'
import type { Task } from '../Task'
import { Field, ID, InputType, ObjectType } from 'type-graphql'
import GraphQLJSON from 'graphql-type-json'
import { TaskSubTasksResult } from './TaskSubTaskResult'

@InputType()
export class AddTaskSubTasksArgs extends ActionArgs {
  @Field(() => ID)
  taskId: string

  @Field(() => GraphQLJSON)
  subTasks: Task[]
}

@ObjectType()
export class AddTaskSubTasksResult extends TaskSubTasksResult {}

export interface IAddTaskSubTasks extends IAction<AddTaskSubTasksResult, AddTaskSubTasksArgs> {}
